export default (carousels) => {
  return new Promise((resolve) => {
    if (!carousels.length) return resolve();

    carousels.forEach((carousel, index) => {
      setTimeout(() => {
        new Swiper(carousel, {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });

        // Resolve the promise after the last carousel is processed
        if (index === carousels.length - 1) {
          resolve();
        }
      }, 0);
    });
  });
};
